import clsx from 'clsx'

interface AvatarProps {
  variant?: string
  size?: 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'
  className?: string
  src?: string
  name?: string
  bgColor?: string
  color?: string
}

const AvatarSizes = {
  xs: '24px',
  s: '32px',
  m: '40px',
  l: '56px',
  xl: '72px',
  xxl: '120px',
}

export default function Avatar({ variant, size, className, src, name, bgColor, color }: AvatarProps) {
  return (
    <>
      {variant === 'circle' && (
        <div
          className={clsx('rounded-full flex justify-center items-center', className)}
          style={{
            backgroundColor: bgColor,
            color: color,
            width: AvatarSizes[size || 'm'],
            height: AvatarSizes[size || 'm'],
          }}
        >
          {name && <span>{name?.charAt(0).toUpperCase()}</span>}
          {src && <img src={src} alt={name} className="w-full h-full object-cover rounded-full" />}
        </div>
      )}
      {variant === 'square' && (
        <div
          className={clsx('rounded flex justify-center items-center', className)}
          style={{
            backgroundColor: bgColor,
            color: color,
            width: AvatarSizes[size || 'm'],
            height: AvatarSizes[size || 'm'],
          }}
        >
          {name && <span>{name?.charAt(0).toUpperCase()}</span>}
          {src && <img src={src} alt={name} className="w-full h-full object-cover rounded" />}
        </div>
      )}
    </>
  )
}
